import { type FC } from 'react'

import {
  TopCarsBannerTabList,
  TopCarsBannerTabListItem,
} from '@/components/brp/top-cars-banner/tabs/styled'
import { type TabsProps } from '@/ui/molecules/tabs'

export const TopCarsBannerTabs: FC<TabsProps> = ({ linkList }) => (
  <nav>
    <TopCarsBannerTabList>
      {linkList.map(({ id, body, href, isSelected, ...rest }, index) => (
        <li key={`tab-list-item-${id || index}`}>
          <TopCarsBannerTabListItem
            $direction="horizontal"
            aria-current={isSelected ? 'page' : false}
            href={href}
            data-testid={id}
            {...rest}
          >
            {body}
          </TopCarsBannerTabListItem>
        </li>
      ))}
    </TopCarsBannerTabList>
  </nav>
)
